import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldAppearance, MatFormFieldModule } from '@angular/material/form-field';
import { Base } from '../../models/base';
import { MatInputModule } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
  selector: 'app-mat-form-field',
  standalone: true,
  templateUrl: './mat-form-field.component.html',
  styleUrls: ['./mat-form-field.component.scss'],
  imports: [ CommonModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, FormsModule, MatIcon, PipesModule]
})
export class MatFormFieldComponent implements OnInit {

  @Input() model: Base.IBase;
  @Input() property: keyof MatFormFieldComponent['model'];
  @Input() charactersLimitation: number;
  @Input() hint: string = '';
  @Input() disabled: boolean = false;
  @Input() inputName: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() min: string = '0';
  @Input() max: string = '';
  @Input() hideCleanButton: boolean = false;
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() maxRows: number = 5;
  @Input() minRows: number = 1;
  @Input() label: string;
  @Input() iconInErrorMessage: string;
  @Input() errorMessage: string;
  @Input() characterLimitationClass: { [key: string]: string } = {};
  @Output() valueChange = new EventEmitter<number>();

  show: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }
  onValueChange(ev:any){
	this.valueChange.emit(ev.target.value);
  }

}


